import React from 'react';
import HomeSection from '../HomeSection';
import { StyledCenterBox } from '../Home.styled';
import { Button, Typography } from '@mui/material';
import BestCombiResult from '../../result/bestcombination/BestCombiResult';
import { useSelectedGamesForBCResult } from '../../../zustand/GamesFromSelectedTeams';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';

const BCSection: React.FC = () => {
  const { gamesFromSelectedTeams } = useSelectedGamesForBCResult();
  return (
    <HomeSection
      buttonTitle={'Details'}
      title={
        <>
          <AutoAwesomeRoundedIcon color="primary" /> Your last best combination:
        </>
      }
      linkTo="/bestcombination"
      content={
        <>
          {gamesFromSelectedTeams.length > 0 ? (
            <>
              <BestCombiResult isPreview />
            </>
          ) : (
            <StyledCenterBox>
              <Typography variant="subtitle2">
                No best combination yet
              </Typography>{' '}
              <br />
              <a href="/favouriteselection">
                <Button variant="outlined" color="secondary">
                  Start finding your best combination
                </Button>
              </a>
            </StyledCenterBox>
          )}
        </>
      }
    />
  );
};
export default BCSection;
